import React from "react";
import { Box } from "@mui/material";
import { FeeNoteColumns } from "../../../data/DynamicTable/Collumns";
import { allFeeNotesView } from "../../../data/Axios/queries";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { accountsmanagement } from "../../../config";
import { useState } from "react";
import FeeNoteDetailDialog from "./FeeNoteDetailDialog";
import FeeNoteForm from "./form";

const base_url = accountsmanagement.uri;

const FeeNote = () => {
  const [openFeeNoteDialog, setOpenFeeNoteDialog] = useState(false);
  const [selectedFeeNote, setSelectedFeeNote] = useState(null);
  const [refreshTable, setRefreshTable] = useState(null);

  const actions = {
    entity: "Fee Note",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ViewFeeNoteLines: {
      key: "VIEWFEENOTELINES",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row, refresh) => {
        setRefreshTable(() => refresh);
        setSelectedFeeNote(row);
        setOpenFeeNoteDialog(true);
      },
    },
    PrintFeeNote: {
      key: "PRINTFEENOTE",
      button_name: "Print",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    sendForapprovalFeeNote: {
      key: "APPROVEFEENOTE",
      button_name: "Sent For Approval",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    showStatus: true,
  };

  return (
    <Box m="10px">
      <DynamicTable
        title="Fee Note"
        subtitle="Fee Note List"
        columns={FeeNoteColumns}
        FormComponent={FeeNoteForm}
        query={allFeeNotesView}
        base_url={base_url}
        actions={actions}
      />

      {openFeeNoteDialog && (
        <FeeNoteDetailDialog
          open={openFeeNoteDialog}
          onClose={() => {
            setOpenFeeNoteDialog(false);
            if (refreshTable) refreshTable();
          }}
          feeNoteData={selectedFeeNote}
          refetchData={() => {
            if (refreshTable) refreshTable();
          }}
        />
      )}
    </Box>
  );
};

export default FeeNote;
